import React from 'react'
import { Link } from "gatsby"
import * as classes from './thumbnail.module.scss'

export default function Thumbnail(props) {
    return (
        <div className={"col-xl-4 col-lg-6 col-12 mb-3 " + classes.ThumbnailWrapper}>
            <Link key={props.project.id} to={'/' + props.project.frontmatter.slug_converted}>
                <figure
                  className={classes.Thumbnail}
                  style={{ backgroundImage: "url(" + props.project.frontmatter.thumbnail.publicURL + ")" }}>
                </figure>
                <div className={classes.ThumbnailDescription}>
                    { props.project.frontmatter.title }
                </div>
            </Link>
        </div>
    )
}

